export enum StatusType {
    STC = 'card.status.in_progress',
    ACC = 'card.status.accepted',
    PICK = 'card.status.ready',
    PED = 'card.status.delivered',
    ERR = 'card.status.error',
    REJ = 'card.status.refused',
    CANR = 'card.status.cancelRequested',
    CAN = 'card.status.canceled'
  }